export const localeConfigurations = {
  en: {
    locales: 'en-US',
    default: {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    short: {
      month: 'short',
      day: 'numeric',
      year: '2-digit',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  fr: {
    locales: 'fr-FR',
    default: {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    short: {
      day: 'numeric',
      month: 'long',
      year: '2-digit',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}